<template>
  <v-app>
    <b-modal ref="my-modal" hide-footer :title="type=='renew'?'Renew Book':'Return Book'">

      <div class="row">
        <div class="col-12">
          <!--          <pre>{{issue}}</pre>-->
          <!--          <v-menu-->
          <!--              ref="menu1"-->
          <!--              v-model="menu1"-->
          <!--              :close-on-content-click="false"-->
          <!--              transition="scale-transition"-->
          <!--              offset-y-->
          <!--              max-width="290px"-->
          <!--              min-width="auto"-->
          <!--          >-->
          <!--            <template v-slot:activator="{ on, attrs }">-->
          <!--              <v-text-field v-if="type =='renew'"-->
          <!--                            v-model="issue.renew_date"-->
          <!--                            label="Renew Date"-->
          <!--                            hint="MM/DD/YYYY format"-->
          <!--                            persistent-hint-->
          <!--                            prepend-icon="mdi-calendar"-->
          <!--                            v-bind="attrs"-->
          <!--                            outlined-->
          <!--                            dense-->
          <!--                            v-on="on"-->
          <!--              ></v-text-field>-->
          <!--              <v-text-field v-else-->
          <!--                            v-model="issue.return_date"-->
          <!--                            label="Return Date"-->
          <!--                            hint="MM/DD/YYYY format"-->
          <!--                            persistent-hint-->
          <!--                            prepend-icon="mdi-calendar"-->
          <!--                            v-bind="attrs"-->
          <!--                            outlined-->
          <!--                            dense-->
          <!--                            v-on="on"-->
          <!--              ></v-text-field>-->
          <!--            </template>-->
          <!--            <v-date-picker-->
          <!--                v-model="date"-->
          <!--                no-title-->
          <!--                @input="menu1 = false"-->
          <!--            ></v-date-picker>-->
          <!--          </v-menu>-->

          <v-text-field v-if="type == 'renew'" type="date" outlined dense v-model="issue.renew_date"></v-text-field>
          <v-text-field v-else type="date" outlined dense v-model="issue.return_date"></v-text-field>
        </div>
      </div>

      <v-row>
        <v-col cols="12" class="text-right">
          <v-btn class="btn btn-default cancel-btn" @click="closeDialog">Cancel</v-btn>
          <v-btn
              class="text-white btn btn-primary btn   font-weight-bold px-9 py-4 my-3 font-size-3 mx-4"
              depressed
              @click="performAction"
              :loading="isBusy"
          >Save
          </v-btn>
        </v-col>
      </v-row>


    </b-modal>
  </v-app>
</template>


<script>
import BookMixin from "@/mixins/BookMixin";

export default {
  name: "ReturnOrRenew",
  props: ['dialog', 'issue', 'type'],
  mixins: [BookMixin],
  data() {
    return {
      menu1: false,
      isBusy: false,
      date: null,
    }
  }, methods: {
    performAction() {
      if (this.type == 'renew') {
        this.renewBook(this.issue)
      } else {
        this.returnBook(this.issue)
      }
    },
    closeDialog() {
      this.issue.renew_date = null;
      this.issue.return_date = null;
      this.$refs['my-modal'].hide()
      this.$emit('close_dialog')
    },
    showModal() {
      this.$refs['my-modal'].show()
    },
    hideModal() {
      this.$refs['my-modal'].hide()
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs['my-modal'].toggle('#toggle-btn')
    }
  }
}
</script>

<style scoped>

</style>